import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';
import ImageCardHorizontal, { ImageCardHorizontalProps } from 'molecules/ImageCardHorizontal/ImageCardHorizontal';
import React from 'react';

interface ContentAndImageCardsHorizontalProps {
  content: React.ReactNode;
  contentPosition?: 'left' | 'right';
  leftLabel?: string;
  rightLabel?: string;
  cards: ImageCardHorizontalProps[];
}

const ContentAndImageCardsHorizontal = ({
  content,
  contentPosition = 'left',
  leftLabel,
  rightLabel,
  cards,
}: ContentAndImageCardsHorizontalProps): JSX.Element => {
  const renderLabel = (label: string) => (
    <Stack
      justify='flex-start'
      align='flex-start'
      paddingLeft='spacing-xl'
      paddingLeftLg='spacing-none'
    >
      <Typography
        type='paragraph'
        size='xl'
        fontWeight='font-weight-semibold'
        textAlign='left'
      >
        {label}
      </Typography>
    </Stack>
  );
  const renderContent = () => (
    <Stack
      columns={7}
      columnsLg={1}
      justify='flex-start'
      align='flex-start'
      direction='column'
      gap='spacing-3xl'
    >
      {leftLabel && renderLabel(leftLabel)}
      {content}
    </Stack>
  );

  const renderCards = () => (
    <Stack
      columns={5}
      justify='flex-start'
      align='flex-start'
      direction='column'
      gap='spacing-3xl'
      columnsLg={1}
    >
      {rightLabel && renderLabel(rightLabel)}
      <Stack
        direction='column'
        gap='spacing-3xl'
      >
        {cards.map((card, index) => (
          <ImageCardHorizontal
            key={index}
            {...card}
          />
        ))}
      </Stack>
    </Stack>
  );

  const renderLeftContent = () => {
    if (contentPosition === 'left') return renderContent();

    return renderCards();
  };

  const renderRightContent = () => {
    if (contentPosition === 'right') return renderContent();

    return renderCards();
  };

  return (
    <Grid
      gap='spacing-4xl'
      totalColumnsLg={1}
      maxWidthLg='width-xl'
    >
      {renderLeftContent()}
      {renderRightContent()}
    </Grid>
  );
};

export default ContentAndImageCardsHorizontal;
